import { InjectionToken } from '@angular/core';
import { Params } from '@angular/router';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';
import { TipoConto } from '@ideapa/common-utils';

export const ENTITY = 'piano-conti';
export const ENTITY_PLURAL = 'piani conti';

// export const gridColumns: EntityListField[] = [
export const gridColumns: (filterParams: Params) => EntityListField[] = (
  filterParams: Params
) => {
  //console.log('filterParams', filterParams);
  return [
    {
      elementLabel: 'Codice',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'codice',
      initialHideColumn: !filterParams['filters'] ? true : false,
      minWidth: 180,
      maxWidth: 200,
    },
    {
      elementLabel: 'Tipo',
      filterType: FilterType.enum,
      fieldType: FieldType.enum,
      field: 'tipo',
      elementValues: TipoConto,
      sortable: true,
      minWidth: 120,
      maxWidth: 150,
    },
    {
      elementLabel: 'Descrizione',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'descrizione',
      minWidth: 420,
    },
    {
      elementLabel: 'Livello',
      filterType: FilterType.number,
      fieldType: FieldType.integer,
      field: 'livello',
      hideFilter: true,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      elementLabel: 'No Bdap',
      filterType: FilterType.boolean,
      fieldType: FieldType.boolean,
      field: 'swNoBdap',
      initialHideColumn: true,
      minWidth: 150,
      maxWidth: 170,
    },
    {
      elementLabel: 'Conto Bdap',
      filterType: FilterType.text,
      fieldType: FieldType.text,
      field: 'contoBdap.codice',
      initialHideColumn: true,
    },
    // {
    //   elementLabel: 'Esercizio',
    //   filterType: FilterType.number,
    //   fieldType: FieldType.integer,
    //   field: 'esercizio',
    //   initialHideColumn: true,
    //   exportHideColumn: false,
    // },
    {
      elementLabel: 'Foglia',
      filterType: FilterType.boolean,
      fieldType: FieldType.boolean,
      field: 'foglia',
      initialHideColumn: true,
      hideFilter: true,
      minWidth: 100,
      maxWidth: 150,
    },
  ];
};
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
